var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point-deduct"},[_c('div',{staticClass:"copy"},[_vm._v("积分抵扣")]),_c('div',{staticClass:"point"},[_c('div',{staticClass:"total"},[_vm._v("200积分")]),_c('div',{staticClass:"detail"},[_vm._v("100积分x2")])])])
}]

export { render, staticRenderFns }